// jquery-global.js
// https://stackoverflow.com/questions/35358625/jquery-is-not-defined-when-use-es6-import/39820703
import jquery from "jquery";

window.jQuery = jquery;
window.$ = jquery;


// WEBPACK FOOTER //
// ./assets/scripts/util/jquery-global.js